import React, { Component } from 'react'
import DocumentTitle from 'react-document-title';
import ArrowTop from '../../static/images/arrow-top.png';
import Nothing from '../../static/images/common/nothing.png';
import AXIOS from '../../api/axios';
import UA from '../../utils/ua';
import { apiCancel, apiDefine } from '../../api/web';
import clientApi from '../../api/client';
import { parseQuery } from '../../utils/tools';
import './style.less'
import Toast from '../../utils/toast';
import { WEEK } from '../../constants'

class ClassRegularPlan extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isMobile: UA.mobileClient,
            currentPlanId: -1, // 当前选择的学习计划id
            currentPlanName: '', // 当前选择的学习计划名称
            plans: [], // 学习计划列表
            classRegularTable: [], // 学习计划对应的课表列表
            currentClassTableId: -1, // 当前选择的课表id
            currentClassTableName: '', // 当前选择的课表名称
            classTable: [],
            effectType: -1, // 0-立即生效 1-隔日生效 2-次周生效
            changeValidDivisionTime: '',
            isLoading: true
        }
    }

    componentDidMount() {
        const queryObj = parseQuery(this.props.location.search.slice(1));
        this.courseId = queryObj.courseid || ''
        this.getClassPlan()
        apiDefine({apiName: 'alertViewBack', fn: this.alertViewBack });
    }

    componentWillUnmount() {
        apiCancel('alertViewBack');
    }

    getClassPlan() {
        AXIOS.getClassPlan({ data: { courseId: this.courseId } }, (res, err) => {
            if (err) Toast.info({text: err.errorMessage});
            if (res && res.list) {
                const { list, effectType, changeValidDivisionTime } = res
                list.forEach(item => {
                    if (item.isSelectPlan) {
                        this.originalPlanId = item.id
                    }
                })
                const defaultPlan = list.find(item => item.isSelectPlan)
                // 默认选中的学习计划
                if (defaultPlan) {
                    // 保存原始的学习计划id和课表id，用于修改时校验
                    this.originalPlanId = defaultPlan.id
                    const defaultTableIndex = defaultPlan.classRegularTable ? defaultPlan.classRegularTable.findIndex(item => item.isSelectPlan) : null
                    if (defaultTableIndex > -1) {
                        const defaultTable = defaultPlan.classRegularTable[defaultTableIndex]
                        this.originalTableId = defaultTable.id
                        this.setState({
                            effectType,
                            changeValidDivisionTime,
                            currentClassTableId: this.originalTableId,
                            currentClassTableName: `课表${defaultTableIndex + 1}`,
                            currentPlanId: this.originalPlanId,
                            currentPlanName: defaultPlan.name,
                            plans: list,
                            classRegularTable: defaultPlan.classRegularTable,
                            classTable: this.normalizeClassTable(defaultTable.classTable)
                        })
                    }
                } else {
                    console.error('找不到默认学习计划')
                    this.setState({
                        plans: list,
                        effectType,
                        changeValidDivisionTime
                    })
                    this.choosePlan(list[0])
                }
            }
            this.setState({ isLoading: false })
        })
    }

    handleSubmit = () => {
        const { currentPlanId, currentClassTableId, plans } = this.state
        if (currentPlanId === this.originalPlanId && currentClassTableId === this.originalTableId) {
            Toast.info({text: '计划与当前一致，无需重复提交'})
            return
        }
        if (!plans || !plans.length) {
            return
        }
        let params = {
            title: '确定修改学习计划',
            content: '您正在提交新的学习计划',
            confirm: '确定',
            cancel: '取消',
            id: 'H5_1002'
        }
        clientApi.alertView(params);
        // 本地模拟客户端回调
        // this.alertViewBack(JSON.stringify({select: 'confirm', id: 'H5_1002'}));
    }

    updateClassPlan() {
        const { currentClassTableId, currentPlanId } = this.state
        AXIOS.updateClassPlan({ data: { courseId: this.courseId, classRegularTableId: currentClassTableId } }, (res, err) => {
            if (err) {
                Toast.info({text: err.errorMessage})
                return
            }
            this.originalTableId = currentClassTableId
            this.originalPlanId = currentPlanId
            Toast.info({text: '修改成功'})
            setTimeout(() => {
                clientApi.closeH5Page({ reason: "closeSafe" })
            }, 2000);
        })
    }

    alertViewBack = (str) => {
        const data = JSON.parse(str);
        const { select } = data;
        if (select === 'confirm') {
            this.updateClassPlan()
        }
    }

    choosePlan = item => {
        this.setState({
            currentPlanId: item.id,
            currentPlanName: item.name,
            classRegularTable: item.classRegularTable,
            currentClassTableId: item.classRegularTable[0].id,
            currentClassTableName: '课表1',
            classTable: this.normalizeClassTable(item.classRegularTable[0].classTable)
        })
    }

    chooseClassTable = (item, index) => {
        this.setState({
            currentClassTableId: item.id,
            currentClassTableName: `课表${index+1}`,
            classTable: this.normalizeClassTable(item.classTable)
        })
    }
    // 将接口返回的课表处理成需要展示的格式
    normalizeClassTable(lists) {
        let result = []
        lists.forEach((item, index) => {
            let duplicateWeek = result.find(v => v.weekDay === item.weekDay)
            if (duplicateWeek) {
                ++duplicateWeek.count
                duplicateWeek.startTimes.push(item.startTime)
                duplicateWeek.endTimes.push(item.endTime)
            } else {
                result.push({
                    weekDay: item.weekDay,
                    count: 1,
                    startTimes: [item.startTime],
                    endTimes: [item.endTime]
                })
            }
        })
        result = result.map(item => {
            item.startTimes = item.startTimes.sort()
            item.endTimes = item.endTimes.sort()
            return item
        })
        return result
    }

   render() {
        const {isLoading, plans, currentPlanId, classRegularTable, currentClassTableId, isMobile, classTable, currentClassTableName, currentPlanName, effectType, changeValidDivisionTime} = this.state
        const hasPlan = plans && plans.length > 0
        return <DocumentTitle title='学习计划'>
            {
                isLoading
                    ? null
                    : <React.Fragment>
                        <div className={`class-regular-plan-wrapper ${!isMobile ? 'pc' : ''}`}>
                            {
                            hasPlan ? <React.Fragment>
                                <div className="common-title">学习计划</div>
                                <div className="common-grid">
                                    {
                                        plans.map((item, index) => {
                                            return <div key={item.id} onClick={() => this.choosePlan(item)} className={`common-item ${currentPlanId === item.id && 'active'}`}>{item.name.length > 4 ? `${item.name.slice(0,4 )}...` : item.name}</div>
                                        })
                                    }
                                </div>
                                <div className="common-title common-title-table">课表计划</div>
                                <div className="common-grid">
                                    {
                                        classRegularTable.map((item, index) => {
                                            return <div key={item.id}
                                                        className={`common-item ${currentClassTableId === item.id && 'active'}`}
                                                        onClick={() => this.chooseClassTable(item, index)}
                                                    >
                                                        {`课表${index+1}`}
                                                    </div>
                                        })
                                    }
                                </div>
                                <div className="class-table-wrap">
                                    <img src={ArrowTop} className="arrow" alt=""/>
                                    {
                                        currentPlanName ? <div className="class-table-title">{currentPlanName}-{currentClassTableName}</div> : null
                                    }
                                    {
                                        classTable.map(item => {
                                            return <div className="class-table-item" key={item.weekDay}>
                                                <span className="class-item-week">{WEEK[item.weekDay]} ：</span>
                                                <span className="class-item-content">
                                                    开课{item.count}节 — {item.startTimes.join('、')}上课
                                                </span>
                                            </div>
                                        })
                                    }
                                </div>
                            </React.Fragment> : <div className="empty-wrap">
                                <img src={Nothing} className="empty-img" alt=""/>
                                <p className="empty-text">这里空空如也～</p>
                            </div>
                            }
                            <div className="footer-btn-wrap">
                                {
                                    hasPlan ? <div className="footer-tip">
                                        { effectType === 0 || effectType === 1 ? `${changeValidDivisionTime}前更改上课时间，当日生效；${changeValidDivisionTime}后更改，次日生效` : effectType === 2 ? '更新学习计划后，次周生效新课表' : '' }
                                    </div> : null
                                }
                                <div className={`footer-btn ${!hasPlan && 'disabled'}`} onClick={this.handleSubmit}>确定学习计划</div>
                            </div>
                        </div>
                    </React.Fragment>
            }
        </DocumentTitle>
   }
}

export default ClassRegularPlan


// WEBPACK FOOTER //
// ./src/components/classRegularPlan/classRegularPlan.jsx